let cachMap = /* @__PURE__ */ new Map();
function cachedFetch(url, options) {
    const cacheKey = url;
    if (cachMap.has(cacheKey)) {
        return Promise.resolve(new Response(new Blob([cachMap.get(cacheKey)])));
    }
    return fetch(url, options).then((response) => {
        if (response.status === 200) {
            const contentType = response.headers.get("Content-Type");
            if (contentType && (contentType.match(/application\/json/i) || contentType.match(/text\//i))) {
                response.clone().text().then((content) => {
                    cachMap.set(cacheKey, content);
                });
            }
        }
        return response;
    });
}

const updatePagination = (previousShopifySection, tempContent) => {
    const previousPagination = previousShopifySection.querySelector(".collection__pagination.pagination")
    const newPagination = tempContent.querySelector(".collection__pagination.pagination")

    if(previousPagination != null && !newPagination) {
        previousPagination.remove()
    }
    if(previousPagination != null && newPagination) {
        previousPagination.replaceWith(tempContent.querySelector(".collection__pagination.pagination")) 
    }
    if(previousPagination == null && newPagination) {
        const filterDrawer = previousShopifySection.querySelector('.collection.collection--filters-drawer')
        filterDrawer && filterDrawer.appendChild(tempContent.querySelector(".collection__pagination.pagination"))
    }
}

const openElements = /* @__PURE__ */ new Set();
document.addEventListener("facet:updatess", async (event) => {
    const url = event.detail.url
    const tag = event.detail.tag
    const tags = event.detail.tags
    const func = event.detail?.func
    const clickedEvent = event.details?.clickedEvent

    const previousShopifySection = document.getElementById(`shopify-section-${url.searchParams.get("section_id")}`); 
    const clonedUrl = new URL(url);
    clonedUrl.searchParams.delete("section_id");
    history.replaceState({}, "", clonedUrl.toString());
    try {
        const tempContent = new DOMParser().parseFromString(await (await cachedFetch(url.toString())).text(), "text/html");

        Array.from(tempContent.querySelectorAll("details, facet-dialog")).forEach((item) => {
            if (openElements.has(item.id)) {
                item.setAttribute("open", "");
            }
        });
           
        updatePagination(previousShopifySection, tempContent)
        func && func(clickedEvent, tempContent, tags)

        previousShopifySection.querySelector(".collection__results")?.replaceWith(tempContent.querySelector(".collection__results"))
        const scrollToElement = window.matchMedia("(min-width: 700px) and (max-width: 999px)").matches ? previousShopifySection.querySelector(".collection__results") : previousShopifySection.querySelector(".collection__results product-list")
        const sideBarFilters = tempContent.querySelector(`.collection__facets input[id='${tag}']`)
        const drawerFilters = tempContent.querySelector(`facet-drawer input[id='${tag}']`)
        if (tag && sideBarFilters) sideBarFilters.checked = true
        if (tag && drawerFilters) drawerFilters.checked = true
        const scrollToBoundingRect = scrollToElement?.getBoundingClientRect();
        if (scrollToBoundingRect && scrollToBoundingRect.top < parseInt(getComputedStyle(scrollToElement).scrollPaddingTop || 0)) {
            scrollToElement.scrollIntoView({ block: "start", behavior: "smooth" });
        }
 
    } catch (e) {
        console.log('error at filter:', e) 
    }
});

class Filters {
    constructor() {
        if(window.themeVariables.settings.pageType !== 'collection') {
            return false; 
        }
        /* LEFT OFF AT theme.js.lqiuid 2260 */
        this.urlPath = window.location.origin+'/collections/'+document.querySelector("[data-handle]")?.dataset.handle
        this.clearFilterBtns = document.querySelectorAll('[data-action="reset-tags"]')    
        this.addListeners = this.addListeners.bind(this)
        this.getTags = this.getTags.bind(this)
        const targetNode = document.getElementById("filter-menu");
        this.setCurrentBubblefilters(false, this.getCheckedElements())
        this.addListeners() 
    }

    setCurrentBubblefilters(e, tags, func) {  
        if(!tags.length) {
            return document.querySelectorAll('[data-action="reset-tags"]').forEach(btn => btn.style.display = "none");
        } 
        
        for(let tag of tags) {
            const parts = tag.split('_')
            const type = parts[0].replace(/(-|_)/g, ' ') 
            const tagName = parts[1].replace(/(-|_)/g, ' ')    
            const currentElement = document.querySelector(`[data-type='${type}']`)
            if(currentElement?.textContent == tagName) {
                this.removeFilter(e, true, type)
                break;
            }
            const button = document.createElement('button')
            button.setAttribute('data-tag', tag)
            button.setAttribute('data-type', type)    
            button.setAttribute('class', 'Makesy__bubbleFilters-item')
            button.textContent = tagName
            if(currentElement) {
                currentElement.replaceWith(button)
                continue;
            } 
            document.querySelector('.Makesy__bubbleFilters_layout').prepend(button)
        }
        document.querySelectorAll('[data-action="reset-tags"]').forEach(btn => btn.style.display = "block");
        func && func(e)
    }

    transformBubbleFilters(bubbleFilter) {
        bubbleFilter.ontransitionend = () => bubbleFilter.remove()
        bubbleFilter.style.transform = 'scale(0)'  
    }
   
    /* 
    * Clicked bubble filter to remove it
    */
    removeFilter(e, clicked_on_same_button=false, type) {
        const bubbleFilter = e.target
        if(bubbleFilter.className === 'Makesy__bubbleFilters-item') {    
            this.transformBubbleFilters(bubbleFilter)
             document.querySelector(`input[id='${bubbleFilter.textContent}']:checked`).checked = false
                
             this.getTags(e) 
        } else if(clicked_on_same_button) {
            this.transformBubbleFilters(document.querySelector(`button[data-type='${type}']`))
            bubbleFilter.checked = false
             this.getTags(e) 
        }
    }      

    getCheckedElements() {
        const checkboxes = document.querySelectorAll(".c-accordian__menu input[type='radio']:checked");
        return Array.from(checkboxes).map(el => el?.parentNode?.dataset.tag)
    }
   
    getTags(e,func) {   
        const target = e.target
        const tags = this.getCheckedElements()  
        if(target.tagName != 'INPUT' && target.tagName != 'BUTTON') {
            return;  
        }
        const tagString = tags.join('+')
 
        const searchParams = new URLSearchParams(tagString), url = new URL(`${this.urlPath}/${tagString}`);
        url.searchParams.append('sort_by','manual')
        url.searchParams.set("section_id", document.querySelector('.c-accordian__menu').getAttribute("section-id"))  
        document.documentElement.dispatchEvent(new CustomEvent("facet:updatess", {
            bubbles: true,
            detail: {
                url: url,
                tag: target.id,
                tags,   
                func,
                clickedEvent: e
            }
        }));
    }

    clearFilters(e) {
        document.querySelectorAll(".c-accordian__menu input[type='radio']:checked").forEach(input => {
            const tag = input.parentNode.getAttribute('data-tag')
            input.checked = false
            for (let bubbleFilter of document.querySelectorAll(`.Makesy__bubbleFilters_layout [data-tag='${tag}']`) ) this.transformBubbleFilters(bubbleFilter);
        }); 
        document.querySelectorAll('[data-action="reset-tags"]').forEach(btn => btn.style.display = "none");  
        this.getTags(e)
    }

    addListeners() {  
        const myObserver = new ResizeObserver(entries => {
            entries.forEach(entry => {
                if(entry.contentRect.width < 1000) {
                    document.querySelector('facet-drawer #filter-menu').onclick = e => this.setCurrentBubblefilters(e, this.getCheckedElements(), this.getTags)
                } else if(window.innerWidth > 1000) {
                    document.querySelector('.collection__facets #filter-menu').onclick = e => this.setCurrentBubblefilters(e, this.getCheckedElements(), this.getTags)
                }
            })
        });
        myObserver.observe(document.body);
        const checkboxContainer = document.querySelector("#filter-menu"); 
        const bubbleFilterContainer = document.querySelector('.Makesy__bubbleFilters_layout')
        // Might not need this if statement below
        if(!checkboxContainer || !bubbleFilterContainer) return;    
        for (let clearBTN of this.clearFilterBtns) clearBTN.onclick = e => this.clearFilters(e) 
        bubbleFilterContainer.onclick = e => this.removeFilter(e)  
    }
}  

const filters = new Filters()

class SortBy {
    constructor() {
        if(window.themeVariables.settings.pageType !== 'collection') {
            return false; 
        }
        this.addListeners()
        const targetNode = document.querySelector('.shopify-section--main-collection')

        const callback = (mutationList, observer) => {

            for (const mutation of mutationList) {
                if (mutation.type === "childList") {
                    this.addListeners()
                }
            }
        };
        const config = { childList: true, subtree: true };
    
        const observer = new MutationObserver(callback);
        targetNode && observer.observe(targetNode, config);
    }

    addListeners() {
        document.querySelector('.collection_drawer_sort').onclick = e => this.sort(e)
    }
    
    sort(event){

        const url = new URL(location.href), sectionId = document.querySelector('main .shopify-section--main-collection').id.replace("shopify-section-", "");
        console.log('sectionId:', sectionId)
        console.log('event.detail.value:', event.target.value)
        url.searchParams.set("sort_by", event.target.value);
        url.searchParams.set("section_id", sectionId);
        url.searchParams.delete("page");
        console.log('THIS',this)
        document.querySelector('.collection_drawer_sort').dispatchEvent(new CustomEvent("facet:update", {
            bubbles: true,
            detail: {
                url
            }
        }));
  
    }
}
const sort = new SortBy()
